module.exports = __webpack_public_path__ + "static/media/Primary_Tips.3de1b8d5.docx";